import { render, staticRenderFns } from "./ord_suite.vue?vue&type=template&id=8d87ab0e&scoped=true&"
import script from "./ord_suite.vue?vue&type=script&lang=js&"
export * from "./ord_suite.vue?vue&type=script&lang=js&"
import style0 from "./ord_suite.vue?vue&type=style&index=0&id=8d87ab0e&scoped=true&lang=css&"
import style1 from "./ord_suite.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d87ab0e",
  null
  
)

export default component.exports